import LegalDocument from '../../components/legal/LegalDocument';
import { paiaManualContent } from '../../content/legal/paia-manual';

export default function PAIAManualPage() {
  return (
    <LegalDocument title="PAIA Manual">
      {paiaManualContent}
    </LegalDocument>
  );
}
